
export default function WhySYG() {
  return (
    <section id="why-syg" className="relative py-32 px-8 lg:px-16">
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://static.readdy.ai/image/af0cbc08a3b78af074c92730eb798524/97ecc0de523df410af9f83e932afe916.jpeg"
          alt="Luxury yacht interior"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <div className="mb-16">
          <div className="w-20 h-px bg-white mb-8 mx-auto"></div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white mb-12 leading-tight">
            Why SYG Yachts
          </h2>
        </div>

        <div className="space-y-8 text-lg md:text-xl leading-relaxed text-white/95">
          <p>
            SYG Yachts operates with discretion, clarity, and commercial intelligence. We are intentionally selective in our mandates, allowing us to provide focused attention, thoughtful strategy, and uncompromising standards to every client we represent.
          </p>
          <p>
            Our role extends beyond brokerage — we act as trusted advisors in a complex, global marketplace.
          </p>
        </div>
      </div>
    </section>
  );
}
